export default "__VITE_ASSET__BUHNjqML__"